import { render, staticRenderFns } from "./AssignServicesToCompanyModal.vue?vue&type=template&id=b9a7a844&"
import script from "./AssignServicesToCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./AssignServicesToCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports